module.exports = __webpack_public_path__ + "files/df4f19aaa35fcde099221400fa409075.png";